<template>
  <div class="container">
    <div class="final-header">
      <img width="300px" src="../assets/img/tutorial4_2.png" />
      <p>축하합니다!</p>
      <p>칙령 제41호의 {{ level }}로 성장했습니다!</p>
    </div>
    <div class="final-presscard">
      <div class="user">
        <h1 class="user-header">DOKDO</h1>
        <div
          v-if="user_image != ''"
          class="user-default-img"
          v-bind:style="{ 'background-image': 'url(' + user_image + ')' }"
        ></div>
        <div v-else class="user-default-img"></div>
        <h2 class="user-name">{{ user_name }}</h2>
        <p>
          칙령 제41호<br />
          {{ level }}
        </p>
      </div>
    </div>
    <router-link
      v-if="articles_foredit.length"
      class="printer"
      to="/print"
      @click.native.prevent="loadforEditArticle"
      >결과 출력소</router-link
    >
    <mypage
      :levelid="this.levelid"
      :pointprops="get_totalpoint"
      :isfinal="true"
      class="final"
    ></mypage>
    <router-link class="replay" to="/" @click.native.prevent="resetState"
      >시작 화면</router-link
    >
  </div>
</template>

<script>
import mypage from './mypage'
import { mapGetters } from 'vuex'
/* eslint-disable */
export default {
  data() {
    return {
      levelid: this.$store.state.levelid,
    };
  },
  components: {
    mypage,
  },
  computed: {
    ...mapGetters(["user_name", "get_totalpoint", "articles_foredit" ,"user_image"]),
    level: function () {
      if (this.levelid == 1) {
        return "독도 알림이";
      } else if (this.levelid == 2) {
        return "독도 돌봄이";
      } else if (this.levelid == 3) {
        return "독도 지킴이";
      } else if (this.levelid == 4) {
        return "독도 지킴이";
      } else {
        return "독도 배움이";
      }
    },
  },
  methods: {
    loadforEditArticle() {
      this.$store.dispatch("loadforEditArticle");
    },
    resetState() {
      this.$store.commit("SetinitialState");
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/finalResult.vue